"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_RESULTS_LIST_CONFIG = exports.EVENT_RESULTS_LIST_FILTERS = exports.EVENT_RESULT_LIST_EMPTY_PAGE = exports.defaultResultsStatuses = exports.MIN_PAGE_SIZE = void 0;
const constants_1 = require("../../domain/results/constants");
const utils_1 = require("./utils");
exports.MIN_PAGE_SIZE = 20;
exports.defaultResultsStatuses = [
    'TRADING',
    'SUSPENDED',
    'OPEN',
    'CANCELLED',
    'INTERRUPTED',
    'POSTPONED',
    'ENDED',
    'CLOSED',
];
exports.EVENT_RESULT_LIST_EMPTY_PAGE = {
    loading: false,
    loaded: false,
    polling: false,
    eventResultsIds: [],
    paginationKeyBackward: undefined,
    paginationKeyForward: undefined,
    paginationKey: undefined,
    paginationKeyDirection: undefined,
};
exports.EVENT_RESULTS_LIST_FILTERS = {
    scheduledFrom: (0, utils_1.formatDate)({
        date: (0, utils_1.createStartDate)(new Date()),
        format: constants_1.DATE_FORMAT,
    }),
    scheduledTo: (0, utils_1.formatDate)({
        date: (0, utils_1.createEndDate)(new Date()),
        format: constants_1.DATE_FORMAT,
    }),
};
exports.EVENT_RESULTS_LIST_CONFIG = {
    statuses: exports.defaultResultsStatuses,
    sort: ['tournamentId.asc', 'scheduledAt.asc'],
    pageSize: 20,
};
//# sourceMappingURL=constants.js.map